export default "__VITE_PUBLIC_ASSET__47c69808__"